import type { RateBase } from "../../../hooks/react-query/backOffice/pricingAndRating/useRateBases";

// Mock dropdown options for Rate Base forms
export const MOCK_RATE_BASE_TYPES = [
  { id: 1, description: "Rateware XL" },
  { id: 2, description: "Commodity Rates" },
  { id: 3, description: "Rate per Handling Unit" },
  { id: 4, description: "Mileage Rates" },
  { id: 5, description: "Truckload" },
  { id: 6, description: "Flat Rates" },
];

export const MOCK_RATE_TARIFFS = [
  { id: 1, value: "DYLT 11-18-2025", label: "DYLT 11-18-2025" },
  { id: 2, value: "DYLT 11-17-2025", label: "DYLT 11-17-2025" },
  { id: 3, value: "DYLT 11-16-2025", label: "DYLT 11-16-2025" },
  { id: 4, value: "DYLT 11-15-2025", label: "DYLT 11-15-2025" },
  { id: 5, value: "DYLT 11-14-2025", label: "DYLT 11-14-2025" },
  { id: 6, value: "DYLT 11-13-2025", label: "DYLT 11-13-2025" },
];

export const MOCK_HANDLING_UNIT_TYPES = [
  { id: 7, value: "CRATES", label: "CRATES" },
  { id: 16, value: "GAYLORDS", label: "GAYLORDS" },
  { id: 32, value: "INTERMEDIATE BULK CO", label: "INTERMEDIATE BULK CO" },
  { id: 12, value: "PALLETS", label: "PALLETS" },
  { id: 27, value: "TOTES", label: "TOTES" },
];

export const MOCK_OVERAGE_RULES = [
  {
    id: 1,
    value: "ltl_class_less_discount",
    label: "LTL (Class Less Discount)",
  },
  {
    id: 2,
    value: "custom_rate_multiplier",
    label: "Custom Rate Multiplier",
  },
  {
    id: 3,
    value: "flat_surcharge_per_unit",
    label: "Flat Surcharge per Unit",
  },
];

// Generate comprehensive mock rate bases based on Figma design
export const mockRateBases: RateBase[] = [
  {
    id: 1,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Rateware XL",
    rateTypeDisplay: "Rateware XL",
    status: "Active",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "John Doe",
    modifiedDate: "2024-11-01T14:45:00Z",
    modifiedBy: "Jane Smith",
  },
  {
    id: 2,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Commodity Rates",
    rateTypeDisplay: "Commodity Rates",
    status: "Active",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "John Doe",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 3,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Active",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Alice Johnson",
    modifiedDate: "2024-10-05T11:30:00Z",
    modifiedBy: "Bob Wilson",
  },
  {
    id: 4,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Draft",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Alice Johnson",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 5,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Truckload",
    rateTypeDisplay: "Truckload",
    status: "Inactive",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Carol Martinez",
    modifiedDate: "2024-09-20T16:00:00Z",
    modifiedBy: "David Brown",
  },
  {
    id: 6,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Active",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Eva Davis",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 7,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Commodity Rates",
    rateTypeDisplay: "Commodity Rates",
    status: "Active",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Frank Miller",
    modifiedDate: "2024-10-15T09:20:00Z",
    modifiedBy: "Grace Lee",
  },
  {
    id: 8,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Commodity Rates",
    rateTypeDisplay: "Commodity Rates",
    status: "Inactive",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Henry Taylor",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 9,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Flat Rates",
    rateTypeDisplay: "Flat Rates",
    status: "Active",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Irene Anderson",
    modifiedDate: "2024-11-05T13:10:00Z",
    modifiedBy: "Jack Thomas",
  },
  {
    id: 10,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB. USD",
    rateType: "Truckload",
    rateTypeDisplay: "Truckload",
    status: "Draft",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Karen White",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 11,
    name: "Premium Rates",
    description: "DYLT 2024/9/15, LB. USD",
    rateType: "Rateware XL",
    rateTypeDisplay: "Rateware XL",
    status: "Active",
    createdDate: "2024-09-15T11:00:00Z",
    createdBy: "Laura Martinez",
    modifiedDate: "2024-10-20T15:30:00Z",
    modifiedBy: "Mike Johnson",
  },
  {
    id: 12,
    name: "Premium Rates",
    description: "DYLT 2024/9/15, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Draft",
    createdDate: "2024-09-15T11:00:00Z",
    createdBy: "Nancy Clark",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 13,
    name: "Express Rates",
    description: "DYLT 2024/10/01, LB. USD",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2024-10-01T09:15:00Z",
    createdBy: "Oliver Harris",
    modifiedDate: "2024-11-10T12:00:00Z",
    modifiedBy: "Patricia Young",
  },
  {
    id: 14,
    name: "Express Rates",
    description: "DYLT 2024/10/01, LB. USD",
    rateType: "Flat Rates",
    rateTypeDisplay: "Flat Rates",
    status: "Active",
    createdDate: "2024-10-01T09:15:00Z",
    createdBy: "Quinn Walker",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 15,
    name: "Economy Rates",
    description: "DYLT 2024/07/01, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Inactive",
    createdDate: "2024-07-01T08:30:00Z",
    createdBy: "Rachel Green",
    modifiedDate: "2024-08-15T10:45:00Z",
    modifiedBy: "Sam Wilson",
  },
  {
    id: 16,
    name: "Economy Rates",
    description: "DYLT 2024/07/01, LB. USD",
    rateType: "Commodity Rates",
    rateTypeDisplay: "Commodity Rates",
    status: "Active",
    createdDate: "2024-07-01T08:30:00Z",
    createdBy: "Tom Baker",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 17,
    name: "Bulk Rates",
    description: "DYLT 2024/11/01, LB. USD",
    rateType: "Truckload",
    rateTypeDisplay: "Truckload",
    status: "Active",
    createdDate: "2024-11-01T10:00:00Z",
    createdBy: "Uma Patel",
    modifiedDate: "2024-11-15T14:20:00Z",
    modifiedBy: "Victor Chen",
  },
  {
    id: 18,
    name: "Bulk Rates",
    description: "DYLT 2024/11/01, LB. USD",
    rateType: "Rateware XL",
    rateTypeDisplay: "Rateware XL",
    status: "Draft",
    createdDate: "2024-11-01T10:00:00Z",
    createdBy: "Wendy Liu",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 19,
    name: "Regional Rates",
    description: "DYLT 2024/06/15, LB. USD",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Inactive",
    createdDate: "2024-06-15T09:45:00Z",
    createdBy: "Xavier Rodriguez",
    modifiedDate: "2024-07-20T11:30:00Z",
    modifiedBy: "Yvonne King",
  },
  {
    id: 20,
    name: "Regional Rates",
    description: "DYLT 2024/06/15, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Active",
    createdDate: "2024-06-15T09:45:00Z",
    createdBy: "Zachary Scott",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 21,
    name: "Seasonal Rates",
    description: "DYLT 2024/12/01, LB. USD",
    rateType: "Flat Rates",
    rateTypeDisplay: "Flat Rates",
    status: "Active",
    createdDate: "2024-12-01T08:00:00Z",
    createdBy: "Amy Turner",
    modifiedDate: "2024-12-10T16:00:00Z",
    modifiedBy: "Brian Adams",
  },
  {
    id: 22,
    name: "Seasonal Rates",
    description: "DYLT 2024/12/01, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Draft",
    createdDate: "2024-12-01T08:00:00Z",
    createdBy: "Catherine Moore",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 23,
    name: "Contract Rates",
    description: "DYLT 2024/05/01, LB. USD",
    rateType: "Commodity Rates",
    rateTypeDisplay: "Commodity Rates",
    status: "Active",
    createdDate: "2024-05-01T10:15:00Z",
    createdBy: "Daniel Phillips",
    modifiedDate: "2024-06-10T12:30:00Z",
    modifiedBy: "Emma Carter",
  },
  {
    id: 24,
    name: "Contract Rates",
    description: "DYLT 2024/05/01, LB. USD",
    rateType: "Truckload",
    rateTypeDisplay: "Truckload",
    status: "Inactive",
    createdDate: "2024-05-01T10:15:00Z",
    createdBy: "Felix Martin",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 25,
    name: "Special Rates",
    description: "DYLT 2024/03/15, LB. USD",
    rateType: "Rateware XL",
    rateTypeDisplay: "Rateware XL",
    status: "Active",
    createdDate: "2024-03-15T09:30:00Z",
    createdBy: "Georgia Hall",
    modifiedDate: "2024-04-20T14:15:00Z",
    modifiedBy: "Harold Evans",
  },
  {
    id: 26,
    name: "Special Rates",
    description: "DYLT 2024/03/15, LB. USD",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2024-03-15T09:30:00Z",
    createdBy: "Isabel Garcia",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 27,
    name: "Promotional Rates",
    description: "DYLT 2024/11/20, LB. USD",
    rateType: "Flat Rates",
    rateTypeDisplay: "Flat Rates",
    status: "Draft",
    createdDate: "2024-11-20T11:00:00Z",
    createdBy: "James Cooper",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 28,
    name: "Promotional Rates",
    description: "DYLT 2024/11/20, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Active",
    createdDate: "2024-11-20T11:00:00Z",
    createdBy: "Kelly Reed",
    modifiedDate: "2024-12-05T10:30:00Z",
    modifiedBy: "Luke Bailey",
  },
  {
    id: 29,
    name: "Overnight Rates",
    description: "DYLT 2024/10/15, LB. USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Active",
    createdDate: "2024-10-15T08:45:00Z",
    createdBy: "Monica Rivera",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 30,
    name: "Overnight Rates",
    description: "DYLT 2024/10/15, LB. USD",
    rateType: "Commodity Rates",
    rateTypeDisplay: "Commodity Rates",
    status: "Inactive",
    createdDate: "2024-10-15T08:45:00Z",
    createdBy: "Nathan Ward",
    modifiedDate: "2024-11-01T09:15:00Z",
    modifiedBy: "Olivia Murphy",
  },
  {
    id: 31,
    name: "Freight Rates",
    description: "DYLT 2024/09/01, LB. USD",
    rateType: "Truckload",
    rateTypeDisplay: "Truckload",
    status: "Active",
    createdDate: "2024-09-01T10:30:00Z",
    createdBy: "Patrick Bell",
    modifiedDate: "2024-10-10T13:45:00Z",
    modifiedBy: "Quincy Ross",
  },
  {
    id: 32,
    name: "Freight Rates",
    description: "DYLT 2024/09/01, LB. USD",
    rateType: "Rateware XL",
    rateTypeDisplay: "Rateware XL",
    status: "Draft",
    createdDate: "2024-09-01T10:30:00Z",
    createdBy: "Ruby Foster",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 33,
    name: "Dedicated Rates",
    description: "DYLT 2024/08/05, LB. USD",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2024-08-05T09:00:00Z",
    createdBy: "Samuel Gray",
    modifiedDate: "2024-09-15T11:20:00Z",
    modifiedBy: "Teresa Hughes",
  },
  {
    id: 34,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB, USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Active",
    createdDate: "2024-08-19T10:30:00Z",
    createdBy: "Carlos Mendez",
    modifiedDate: "2024-11-01T14:45:00Z",
    modifiedBy: "Jane Smith",
  },
  {
    id: 35,
    name: "Premium Handling Rates",
    description: "DYLT 2024/10/01, LB, USD",
    rateType: "Rate per Handling Unit",
    rateTypeDisplay: "Rate per Handling Unit",
    status: "Draft",
    createdDate: "2024-10-01T09:00:00Z",
    createdBy: "Sarah Kim",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 201,
    name: "Mileage Rate with Criteria Test",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-05-22T08:00:00Z",
    createdBy: "System Admin",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 156,
    name: "Mileage Rate - Standard 1",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-05-14T08:00:00Z",
    createdBy: "Michael Johnson",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 122,
    name: "Mileage Rate - Standard 2",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-05-12T09:30:00Z",
    createdBy: "Sarah Wilson",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 54,
    name: "Mileage Rate - Standard",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-04-30T10:00:00Z",
    createdBy: "David Brown",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 6,
    name: "Mileage Rate with Criteria",
    description: "Test mileage rate with criteria",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-04-23T11:00:00Z",
    createdBy: "Robert Martinez",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 5,
    name: "Test Mileage Rate with Criteria",
    description: "Test mileage rate with criteria",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-04-23T12:00:00Z",
    createdBy: "Christopher Lee",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 47,
    name: "Mileage Rate - Standard 2",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-05-14T08:00:00Z",
    createdBy: "System Admin",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 45,
    name: "Mileage Rate Standard",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-05-12T08:00:00Z",
    createdBy: "System Admin",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 2,
    name: "QA Testing",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-04-27T08:00:00Z",
    createdBy: "QA Team",
    modifiedDate: null,
    modifiedBy: null,
  },
  {
    id: 3,
    name: "QA Testing1",
    description: "Standard mileage-based rates with distance bands",
    rateType: "Mileage Rates",
    rateTypeDisplay: "Mileage Rates",
    status: "Active",
    createdDate: "2026-04-27T09:00:00Z",
    createdBy: "QA Team",
    modifiedDate: null,
    modifiedBy: null,
  },
];

export const mockTruckloadDetail = {
  id: 17,
  rateBaseName: "Bulk Rates",
  description: "DYLT 2024/11/01, LB. USD",
  rateType: "Truckload",
  status: "Active",
  serviceLevel: [1, 3],
  lanes: [
    {
      id: 1,
      originType: "State",
      origin: "CA",
      destinationType: "State",
      destinationLocation: "AR",
      ratePerLoad: "1250.50",
      direction: "Both Ways",
    },
    {
      id: 2,
      originType: "Zone",
      origin: "Z001",
      destinationType: "Region",
      destinationLocation: "R002",
      ratePerLoad: "2100.00",
      direction: "One Way",
    },
  ],
  createdDate: "2024-11-01T10:00:00Z",
  createdBy: "Uma Patel",
  modifiedDate: "2024-11-15T14:20:00Z",
  modifiedBy: "Victor Chen",
};

export const mockCommodityRatesDetail = {
  id: 2,
  rateBaseName: "Standard Rates",
  description: "DYLT 2024/8/19, LB. USD",
  rateType: "Commodity Rates",
  status: "Active",
  serviceLevel: [1, 2],
  ratePerUnit: "100",
  lanes: [
    {
      id: 1,
      originType: "State",
      origin: "CA",
      destinationType: "State",
      destinationLocation: "AL",
      minimumCharge: "125.00",
      direction: "Both Ways",
    },
    {
      id: 2,
      originType: "State",
      origin: "CA",
      destinationType: "State",
      destinationLocation: "AL",
      minimumCharge: "501",
      direction: "One Way",
    },
    {
      id: 3,
      originType: "Zone",
      origin: "Z001",
      destinationType: "Region",
      destinationLocation: "R002",
      minimumCharge: "100",
      direction: "Both Ways",
    },
  ],
  createdDate: "2024-08-19T10:30:00Z",
  createdBy: "John Doe",
  modifiedDate: null,
  modifiedBy: null,
};

export const mockRatePerHandlingUnitDetail = {
  id: 160,
  rateBaseName: "East Coast HU Rate Base 2024567",
  description:
    "Handling unit based rates for East Coast operations with multiple lane configurations",
  rateType: "Rate per Handling Unit",
  status: "Active",
  serviceLevel: [1, 3],
  handlingUnits: [12, 7],
  maxUnits: "14",
  maxWeight: "2000",
  maxLength: "48",
  maxWidth: "40",
  maxHeight: "48",
  dimensionsExceeded: "LTL (Class Less Discount)",
  dimensionsExceededRateMultiplier: "",
  maxUnitsExceeded: "Custom Rate Multiplier",
  maxUnitsExceededRateMultiplier: "1.5",
  weightPerUnitExceeded: "Flat Surcharge per Unit",
  weightPerUnitExceededRateMultiplier: "",
  rateTypeSections: [
    {
      id: "section-1-byUnitCountLanes",
      kind: "byUnitCountLanes" as const,
      lanes: [
        {
          id: "lane-1-1",
          sequence: 1,
          originType: "State",
          originLocation: "NY",
          destinationType: "State",
          destinationLocation: "PA",
          minimumCharge: "120.50",
          ratePerUnit: "",
          oneWay: false,
        },
        {
          id: "lane-1-2",
          sequence: 2,
          originType: "State",
          originLocation: "MA",
          destinationType: "State",
          destinationLocation: "CT",
          minimumCharge: "95.00",
          ratePerUnit: "",
          oneWay: true,
        },
      ],
    },
    {
      id: "section-2-singleRate",
      kind: "singleRate" as const,
      lanes: [
        {
          id: "lane-2-1",
          sequence: 1,
          originType: "State",
          originLocation: "NJ",
          destinationType: "State",
          destinationLocation: "DE",
          minimumCharge: "",
          ratePerUnit: "25.00",
          oneWay: false,
        },
      ],
    },
    {
      id: "section-3-byAvgWeightLanes",
      kind: "byAvgWeightLanes" as const,
      lanes: [
        {
          id: "lane-3-1",
          sequence: 1,
          originType: "State",
          originLocation: "MD",
          destinationType: "State",
          destinationLocation: "VA",
          minimumCharge: "150.00",
          ratePerUnit: "",
          oneWay: false,
        },
      ],
    },
  ],
  createdDate: "2026-05-15T10:30:00Z",
  createdBy: "System Admin",
  modifiedDate: "2026-05-20T14:45:00Z",
  modifiedBy: "Jane Smith",
};
